/**
 * The app-bar title size, a step down from `h6` on a phone.
 *
 * A title shares its bar with buttons that cannot shrink — the menu or back
 * arrow, sync state, close — so on a narrow screen the type is what has to
 * give. Spread onto a `variant="h6"` Typography so the h6 weight is kept and
 * only the size moves; `subtitle1` would also drop the weight to 400.
 *
 * One token rather than a literal per bar: the field chrome and the fullscreen
 * record dialogs should not drift apart in size.
 */
export const APP_BAR_TITLE_SX = {
    fontSize: { xs: '1.05rem', sm: '1.25rem' }
};
